module.exports = __webpack_public_path__ + "static/img/login.d53dbf2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newimages/login.png
// module id = iNaw
// module chunks = 48